export enum ThreadFilterType {
    unhandled = 1,
    handledByMe = 2,
    handled = 3,
    unansweredThreads = 4,
    questions = 5,
    badWords = 6,
    essence = 7,
}
